<template>
  <div class="form-group">
    <div class="form">
      <label class="label-tag">
        {{ $t('ct-tag') }}
        <input type="text" v-model="tag" class="form-control" :placeholder="$t('ct-tag-plch')" @change="changeValue" @keyup="changeValue"
               @toggle="changeValue">
      </label>
    </div>
	<alert-box-component type="warning" :with_icon="true" class="alert-tag">
		<p
			slot="content"
			v-text="$t('ct-alert-tag')"
		/>
	</alert-box-component>
  </div>
</template>

<script>

import AlertBoxComponent from '../../commons/AlertBoxComponent';

	export default {
		name: 'TagComponent',
		components: {
    		AlertBoxComponent
		},
		data() {
			return {
				tag: '',
			}
		},
		methods: {
			changeValue() {
				this.element.internal_config.tag = this.tag;
			},
			setValues(tagValue, elem) {
				this.element = elem;
				this.tag = tagValue;
			}
		},
	}

</script>

<style scoped lang="scss">

  .form-group {
    overflow: hidden;
  }

  .label-tag {
	width: 100%;
}
</style>







// WEBPACK FOOTER //
// src/components/editor/resources/Tag.vue